import { types } from 'mobx-state-tree'
import { Address } from './Address'

const TransactionTypes = {
  Transaction: 'Transaction',
  Refund: 'REFUND',
}

const TransasctionApiType = {
  transaction: 'TRANSACTION',
  settlements: 'SETTLEMENT',
  refunds: 'REFUND',
}

const ResponseType = {
  CUSTOM: 'CUSTOM',
  DEFAULT: 'DEFAULT',
  ALL: 'ALL',
}

const MediaType = {
  XLSX: 'XLSX',
  TXT: 'TXT',
  JSON: 'JSON',
}

const transactionStatus = {
  Success: 'SUCCESS',
  Failure: 'FAILURE',
  Failed: 'FAILED',
  Bounced: 'BOUNCED',
  Dropped: 'DROPPED',
  Awaited: 'AWAITED',
  Pending: 'PENDING',
  connfirm: 'CONFIRM_ACCEPTED',
  initiated: 'INITIATED',
  inprocess: 'INPROCESS',
}

const Customer = types.model('Customer', {
  id: types.optional(types.string, ''),
  name: types.optional(types.string, ''),
  mobileNumber: types.string,
  email: types.string,
  address: types.maybe(Address),
})

const Payment = types.model('Payment', {
  paymentMode: types.optional(types.string, ''),
  paymentType: types.optional(types.string, ''),
  accountNumber: types.optional(types.string, ''),
  cardCountryCode: types.optional(types.string, ''), // The card schemes use this field – Issuing Country Code. Defines the Country Code for the issuer. It is 356 for India.
  cardLogoId: types.optional(types.string, ''), // asked
  offerId: types.optional(types.string, ''),
  settlementRefNumber: types.optional(types.string, ''),
  udf1: types.optional(types.string, ''),
  udf2: types.optional(types.string, ''),
  udf3: types.optional(types.string, ''),
  udf4: types.optional(types.string, ''),
  udf5: types.optional(types.string, ''),
})

const Disputes = types.model('Disputes', {
  chargeBackReasonCode: types.optional(types.string, ''),
  chargeBackDate: types.optional(types.string, ''), // whats charge back
  replyBeforeDate: types.optional(types.string, ''), // whats reply brefore
})

const Offer = types.model('Offer', {
  merchantOfferRefId: types.optional(types.string, ''),
  offerKey: types.optional(types.string, ''), // how many keys are there is it enum
  instantDiscountAmount: types.optional(types.number, 0),
  instantDiscountStatus: types.optional(types.string, ''), // asked
  cashBackAmount: types.optional(types.number, 0),
  cashbackStatus: types.optional(types.string, ''), // asked
  offerCompolsoryFlag: types.optional(types.boolean, false),
  offerTransactionAmount: types.optional(types.number, 0),
  offerReferenceId: types.optional(types.string, ''),
  offerCode: types.optional(types.string, ''),
})

const Refund = types.model('Refund', {
  amount: types.optional(types.number, 0), // refunded amount
  pending: types.optional(types.number, 0),
  requestedDate: types.optional(types.string, ''),
  processdDate: types.optional(types.string, ''),
  status: types.optional(types.string, ''), // need to check in BRD
  refundMessage: types.optional(types.string, ''),
  processed: types.optional(types.string, ''),
  sourceSystem: types.optional(types.string, ''),
  invoiceId: types.optional(types.string, ''),
})

const SettlementDetails = types.model('SettlementDetails', {
  referenceNumber: types.optional(types.string, ''),
  fileName: types.optional(types.string, ''),
  neftNumber: types.optional(types.string, ''),
  status: types.optional(types.string, ''), // need to check in BRD for enum
  commisionCharge: types.optional(types.number, 0),
  totalTaxOnCommission: types.optional(types.number, 0),
  settledAmount: types.optional(types.number, 0),
  date: types.optional(types.string, ''),
})

const RefundHistory = types.model('RefundHistory', {
  rrn: types.optional(types.string, ''),
  trxAmount: types.optional(types.number, 0),
  refundAmount: types.optional(types.number, 0),
  initiatedDate: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
  processedOn: types.optional(types.string, ''),
  arn: types.optional(types.string, ''),
})

const Pagination = types.model('Pagination', {
  size: types.optional(types.number, 0),
  totalElements: types.optional(types.number, 0),
  totalPages: types.optional(types.number, 0),
  number: types.optional(types.number, 0),
})

const ConvenienceFee = types.model('Pagination', {
  amount: types.optional(types.string, '0'),
  originalTxnAmt: types.optional(types.string, '0'),
  ugst: types.optional(types.string, '0'),
  cgst: types.optional(types.string, '0'),
  sgst: types.optional(types.string, '0'),
  igst: types.optional(types.string, '0'),
})

const SplitTransaction = types.model('SplitTransaction', {
  amount: types.optional(types.string, ''),
  initiatedDate: types.optional(types.string, ''),
  beneficiaryName: types.optional(types.string, ''),
  status: types.optional(types.string, ''),
})

const Transaction = types.model('Transactions', {
  id: types.optional(types.string, ''),
  date: types.optional(types.string, ''), // DD-MM-YYYY at HH:MM:SS
  ern: types.optional(types.string, ''),
  failureReason: types.optional(types.string, ''),
  rrn: types.optional(types.string, ''),
  amount: types.optional(types.number, 0),
  status: types.optional(types.string, ''), // types.optional(types.enumeration(Object.values(transactionStatus)), transactionStatus.Awaited),
  bankRefNumber: types.optional(types.string, ''),
  type: types.optional(types.string, ''),
  action: types.optional(types.string, ''), // how to compute this based on data
  authCode: types.optional(types.string, ''), // Authorization Code provided by Issuer for a transaction
  acquirerTerminal: types.optional(types.string, ''), // Terminal ID on which the transaction was acquired
  surCharge: types.optional(types.number, 0), // This is like fuel surcharge
  convenienceFeeAmount: types.optional(types.number, 0), // Convenience Fee. IRCTC like merchants don’t bear the MDR. They pass it on to the customer & it is called Convenience Fee
  emiCode: types.optional(types.string, ''), // asked
  merchantName: types.optional(types.string, ''), // asked
  merchantType: types.optional(types.string, ''), // asked
  taxOnConvenienceFee: types.optional(types.number, 0),
  amtDebitedFromCust: types.optional(types.number, 0), // ?
  transactionClass: types.optional(types.string, ''), // Internal code classification of transactions – like Purchase(WPP), Load Money (LMU/LMW) etc.
  customer: Customer,
  payment: Payment,
  disputes: types.maybe(Disputes),
  offer: types.maybe(Offer),
  refund: Refund,
  settlementDetails: types.maybe(SettlementDetails),
  refundHistory: types.array(RefundHistory),
  txnType: types.optional(types.enumeration(Object.values(TransactionTypes)), TransactionTypes.Transaction),
  originalTransactionId: types.optional(types.string, ''),
  failureMessage: types.optional(types.string, ''),
  convenienceFee: types.maybe(ConvenienceFee),
  splitTxns: types.array(SplitTransaction),
  essStatus: types.optional(types.string, ''),
  essSettlementGrossAmount: types.optional(types.number, 0),
  timestamp: types.optional(types.string, '')
})
export interface TransactionTable {
  id: string
  date: string
  ERN: string
  RRN: string
  totalAmount: string
  transactionStatus: string
  paymentMode: string
  paymentType: string
  bankRefNo: string
  transactionType: string
  settlementReferenceNumber: string
  accountNumber: string
  refundAmount: string
  authCode: string
  acquirerTerminal: string
  surCharge: string
  convenienceFeeAmount: string
  emiCode: string
  merchantName: string
  merchantType: string
  settlementStatus: string
  settledAmount: string
  chargeBackReason: string
  refundStatus: string
  settlementDate: string
  customerId: string
  customerName: string
  mobileNumber: string
  email: string
}

export interface RefundProcessed {
  id: string
  rrn: string
  amount: string
  refundAmount: string
  transactionStatus: string
  message: string
}

export {
  Customer,
  Disputes,
  MediaType,
  Offer,
  Pagination,
  Payment,
  Refund,
  RefundHistory,
  ResponseType,
  SettlementDetails,
  Transaction,
  TransactionTypes,
  TransasctionApiType,
  transactionStatus,
}
